import React from 'react';

const InfoSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7194_4071)">
      <path d="M16 16H0V0H16V16ZM7.34668 10.9678V12.2725H8.65137V10.9678H7.34668ZM7.35254 9.39551H8.65332V3.72754H7.35254V9.39551Z" fill="white" fillOpacity="0.6" />
    </g>
    <defs>
      <clipPath id="clip0_7194_4071">
        <rect width="16" height="16" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoSvg;
